import Image, { type StaticImageData } from 'next/image';
import React from 'react';
import TenantLogo from '@/components/common/tenant-logo';

type CardProps = {
  src: StaticImageData;
  alt: string;
};

const CryptoCard = ({ src, alt }: CardProps) => {
  return (
    <div className="relative flex items-center justify-center ">
      <Image
        src={src}
        width={500}
        height={300}
        alt={alt}
        unoptimized
      />
      <TenantLogo className="absolute bottom-4 right-4 h-6 w-24" />
    </div>
  );
};

export default CryptoCard;
